import type { ButtonHTMLAttributes } from 'react';
import { cx } from './cx.js';

type Variant = 'primary' | 'ghost';

const VARIANTS: Record<Variant, string> = {
  primary: 'bg-viana-secondary text-white hover:bg-viana-primary',
  ghost: 'bg-transparent text-slate-700 hover:bg-slate-100',
};

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
}

export function Button({ variant = 'primary', className, ...props }: ButtonProps) {
  return (
    <button
      className={cx(
        'inline-flex items-center justify-center gap-2 rounded-lg px-4 py-2 text-sm font-medium',
        'transition-colors disabled:cursor-not-allowed disabled:opacity-50',
        VARIANTS[variant],
        className,
      )}
      {...props}
    />
  );
}
